import moment from "moment";
import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import { formatMobileNumber } from "@/utils/formInputUtils";
import images from "@/utils/images";
import { trackEvent } from "@/utils/EventTrackingUtil";

const ConfirmPrimaryAccountInfo = (props) => {
  const { accountData, nextStep, prevStep } = props;

  return (
    <>
      <div className="p-5">
        <div className="fs-22 txt-pri mb-5 text-center tw:font-bold">Is this correct?</div>

        <div className="text-center my-5">
          <img
            alt="Step 1/3"
            className="signup-progress-bar"
            src={images("./signup/progress-1.png")}
          />
        </div>

        <div className="brand-popup-inner-card" style={{ maxWidth: 500 }}>
          <div className="d-lg-flex justify-content-lg-between d-block">
            <div className="my-2" style={{ minWidth: 300 }}>
              <div>Name</div>
              <div className="tw:font-bold">
                {accountData && `${accountData.first_name} ${accountData.last_name}`}
              </div>
            </div>

            <div className="my-2" style={{ minWidth: 300 }}>
              <div>Phone Number</div>
              <div className="tw:font-bold">
                {accountData && formatMobileNumber(accountData.mobile)}
              </div>
            </div>
          </div>

          <div className="d-lg-flex justify-content-lg-between d-block">
            <div className="my-2" style={{ minWidth: 300 }}>
              <div>Date of Birth</div>
              <div className="tw:font-bold">
                {accountData &&
                  accountData.dob &&
                  moment(accountData.dob, "MMDDYYYY").format("MM/DD/YYYY")}
              </div>
            </div>

            <div className="my-2" style={{ minWidth: 300 }}>
              <div>Email Address</div>
              <div className="tw:font-bold">{accountData && accountData.email}</div>
            </div>
          </div>

          <div className="d-flex justify-content-between mt-5">
            <div>
              <Button2 className="tw:min-w-35" onClick={prevStep} size="xl" variant="secondary">
                Edit
              </Button2>
            </div>

            <div>
              <Button2
                className="tw:min-w-35"
                onPress={() => {
                  trackEvent("Self Sign-up Create Account");
                  nextStep();
                }}
                size="xl"
              >
                Yes
              </Button2>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmPrimaryAccountInfo;
